import { gatewayRequests } from './http-client';
import {
  RecognizePackageGoodsResponseDto,
  RecognizePackageGoodsVoicePayload,
} from '../models/gateway-ai';

const RECOGNIZE_DOCUMENT_URL = '/api/ai-service/document-recognition/recognize';

const MIME_EXTENSIONS: Record<string, string> = {
  'audio/webm': 'webm',
  'audio/ogg': 'ogg',
  'audio/mp4': 'm4a',
  'audio/mpeg': 'mp3',
  'audio/wav': 'wav',
};

const resolveBaseMimeType = (mimeType: string) =>
  mimeType.split(';')[0].trim().toLowerCase();

const resolveFileExtension = (mimeType: string) =>
  MIME_EXTENSIONS[resolveBaseMimeType(mimeType)] ?? 'webm';

const normalizeAudioMimeType = (audio: Blob, mimeType: string) => {
  const baseMimeType = resolveBaseMimeType(mimeType || audio.type);

  return audio.type === baseMimeType
    ? audio
    : audio.slice(0, audio.size, baseMimeType);
};

const buildRecognitionFormData = (
  file: Blob,
  type: 'PACKAGE_GOOD' | 'PACKAGE_GOOD_VOICE',
  fileName?: string
) => {
  const formData = new FormData();
  const request = { source: 'C2C', type };

  formData.append(
    'request',
    new Blob([JSON.stringify(request)], { type: 'application/json' })
  );
  formData.append('file', file, fileName);

  return formData;
};

const GatewayAiService = {
  recognizePackageGoods: (file: File) =>
    gatewayRequests.post<RecognizePackageGoodsResponseDto>(
      RECOGNIZE_DOCUMENT_URL,
      buildRecognitionFormData(file, 'PACKAGE_GOOD', file.name)
    ),

  recognizePackageGoodsVoice: ({
    audio,
    mimeType,
  }: RecognizePackageGoodsVoicePayload) => {
    const normalizedAudio = normalizeAudioMimeType(audio, mimeType);

    return gatewayRequests.post<RecognizePackageGoodsResponseDto>(
      RECOGNIZE_DOCUMENT_URL,
      buildRecognitionFormData(
        normalizedAudio,
        'PACKAGE_GOOD_VOICE',
        `declaration.${resolveFileExtension(mimeType)}`
      )
    );
  },
};

export default GatewayAiService;
